<script lang="ts">
  import Icon from '../components/icons/Icon.svelte';
  import * as Icons from 'lucide-svelte';
</script>

<aside class="LayoutSearch">
  <div class="searchInput lyBorder lyRounded">
    <span><Icon icon={Icons.Search} size={1} /></span>
    <input type="text" placeholder="Suchen&hellip;" />
  </div>
</aside>

<style lang="scss">
  @use '../../styles/mixins';

  .LayoutSearch {
    display: none;
    min-width: 0;

    @include mixins.greaterNav() {
      display: block;
      width: auto;
    }

    .searchInput {
      display: flex;
      gap: 0.5em;
      font-size: calc(var(--font-size) * 1.5);
      max-width: 15rem;
      min-width: 0;

      span {
        position: relative;
        top: 0.35em;
        left: 0.35em;
        font-size: 0.8em;
      }

      input {
        display: block;
        border: none !important;
        outline: none !important;
        margin: 0.35em 0.25em 0.35em 0;
        font-size: 0.75em;
        min-width: 0;
        width: 100%;
      }
    }
  }
</style>
